import { render, staticRenderFns } from "./SelectResourceField.vue?vue&type=template&id=0c6da3a0&"
import script from "./SelectResourceField.vue?vue&type=script&lang=js&"
export * from "./SelectResourceField.vue?vue&type=script&lang=js&"
import style0 from "./SelectResourceField.vue?vue&type=style&index=0&id=0c6da3a0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c6da3a0')) {
      api.createRecord('0c6da3a0', component.options)
    } else {
      api.reload('0c6da3a0', component.options)
    }
    module.hot.accept("./SelectResourceField.vue?vue&type=template&id=0c6da3a0&", function () {
      api.rerender('0c6da3a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/select-resource/SelectResourceField.vue"
export default component.exports